import { prefixObjectValues } from '../../utils';
const form = {
  formDialog: 'dialog',
  form: 'form',
  nextBtn: 'btn-next',
  closeBtn: 'btn-close',
  prevBtn: 'btn-prev',
  submitBtn: 'btn-submit',
  trainingTypeSelect: 'type-select',
  facilityNameInput: 'facility-name',
  facilityAddressLine1: 'facility-address-line-1',
  facilityAddressLine2: 'facility-address-line-2',
  facilityAddressCity: 'facility-address-city',
  facilityAddressState: 'facility-address-state',
  facilityAddressCountry: 'facility-address-country',
  facilityAddressPostalCode: 'facility-address-postalCode',
  medicalBoardSelect: 'medical-board-select',
  specCertSelect: 'spec-cert-select',
  specBoardSelect: 'spec-board-select',
  subSpecCertSelect: 'sub-spec-cert-select',
  subSpecFlag: 'sub-spec-flag',
  startDate: 'start-date',
  endDate: 'end-date',
  completedToggle: 'completed-flag',
  completionDate: 'completion-date',
  explainTextBox: 'explain-text-box',
};

export default prefixObjectValues(form, 'academic-training-wizard-form');
